import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { StyledEngineProvider, ThemeProvider, createTheme } from "@mui/material/styles";
import { tooltipThemeComponents } from "./theme/tooltipTheme";
import { installSessionExpiryInterceptor } from "./helper/sessionExpiry";

// One accent for everything interactive (buttons, links, steps, focus,
// selected states): the blue of the side menu's selected entry, so the
// pages and the menu share one highlight. Navy stays the structural chrome
// (bars, headers, card buttons). Otherwise the default theme; the tooltip
// look is shared.
export const ACCENT_BLUE = "#4C7EFF";
const theme = createTheme({
  palette: {
    primary: { main: ACCENT_BLUE, dark: "#3B6AE6", light: "#7FA2FF", contrastText: "#ffffff" },
  },
  components: tooltipThemeComponents,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <App />
      </ThemeProvider>
    </StyledEngineProvider>
  </React.StrictMode>
);
function setAxiosAuthorization() {
  if ( localStorage.getItem("token")!=null && localStorage.getItem("token").length > 0) {
    axios.defaults.headers.common["Authorization"] =
      "Token " + localStorage.getItem("token");
  }
}
axios.defaults.baseURL =
  process.env.REACT_APP_API_URL || "http://localhost:8000/";
//axios.defaults.baseURL = "https://oraclase.app/";
setAxiosAuthorization();

// Keep auth header in sync for every request.
axios.interceptors.request.use((config) => {
  const tk = localStorage.getItem("token");
  if (tk && tk.length > 0) {
    config.headers = config.headers || {};
    config.headers.Authorization = "Token " + tk;
  }
  return config;
});
// A 401 from the backend ends the session: the token was refused (sign-out
// after inactivity, or the account was deactivated).
installSessionExpiryInterceptor(axios);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
